import React from 'react';
import {
    AcceptedSvg,
    DeclinedSvg,
    PendingSvg,
    SavedSvg,
    CompletedHandedInSvg,
    CompletedRegisteredSvg,
    NotYetReachedHandInSvg,
    NotYetReachedRegisterSvg,
    EvaluatedSvg,
    FailedSvg,
    NotYetFillProjectInformationSVGCircle,
    NotYetSelectSupervisorSVGCircle,
    FilledProjectInformationSVGCircle,
    SelectingSupervisorSVGCircle,
    WithdrawnSvg,
} from './ProgressBarSvgs';

export const ProgressBarSaved = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <SavedSvg />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <NotYetReachedRegisterSvg />
            </div>
            <div className='project-progress-bar-item'>
                <NotYetReachedHandInSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarProposed = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <PendingSvg />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <NotYetReachedRegisterSvg />
            </div>
            <div className='project-progress-bar-item'>
                <NotYetReachedHandInSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarDeclined = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <DeclinedSvg />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <NotYetReachedRegisterSvg />
            </div>
            <div className='project-progress-bar-item'>
                <NotYetReachedHandInSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarAccepted = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <AcceptedSvg />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <NotYetReachedRegisterSvg />
            </div>
            <div className='project-progress-bar-item'>
                <NotYetReachedHandInSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarRegistered = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <AcceptedSvg />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <CompletedRegisteredSvg />
            </div>
            <div className='project-progress-bar-item'>
                <NotYetReachedHandInSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarHandedIn = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <AcceptedSvg />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <CompletedRegisteredSvg />
            </div>
            <div className='project-progress-bar-item'>
                <CompletedHandedInSvg />
            </div>
        </React.Fragment>
    );
};

interface ProgressBarEvaluatedProps {
    evaluatedString: string;
}

export const ProgressBarEvaluated = ({
    evaluatedString,
}: ProgressBarEvaluatedProps) => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <EvaluatedSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarFailed = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <FailedSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarWithdrawn = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <WithdrawnSvg />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarProjectInformation = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <NotYetFillProjectInformationSVGCircle />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <NotYetSelectSupervisorSVGCircle />
            </div>
        </React.Fragment>
    );
};

export const ProgressBarSelectSupervisor = () => {
    return (
        <React.Fragment>
            <div className='project-progress-bar-item'>
                <FilledProjectInformationSVGCircle />
            </div>{' '}
            <div className='project-progress-bar-item'>
                <SelectingSupervisorSVGCircle />
            </div>
        </React.Fragment>
    );
};
